/* eslint-disable no-empty */
export class JsonHelper {
  static IsJson(input: any): boolean {
    try {
      //check if the string exists
      if (input) {
        const o = JSON.parse(input);

        //validate the result too
        if (o && o.constructor === Object) {
          return true;
        }
      }
    } catch (e) {}

    return false;
  }
}
